<template>
    <span>
        <i v-if="document.read_by" :class="['cursor-pointer text-muted mr-1', iconClass]" data-toggle="popover" data-placement="left" :data-content="getReadContent()"></i>
        <i v-else :class="['text-muted mr-1', iconClass]"></i>
        <a v-if="showName" :class="{ 'font-weight-bold': unread }" :href="href" target="_blank">{{ document.document_type.name }}</a>
    </span>   
</template>

<script>
import { DocumentType } from '../../constants.js';

export default {
    props: {
        document: Object,
        href: String
    },
    data() {
        return {
            DocumentType: DocumentType,
            incoming: [
                DocumentType.INBOUND_FAX, 
                DocumentType.LWC_FORM_1010_RESPONSE, 
                DocumentType.LWC_FORM_1010A, 
                DocumentType.LWC_FORM_1009_RESPONSE, 
                DocumentType.REMITTANCE,
                DocumentType.CORRESPONDENCE
            ]          
        }
    },
    computed: {
        iconClass: function () {

            let icon = 'fas fa-file';

            if (this.document.document_type) {

                switch(parseInt(this.document.document_type.id)) {
                    case DocumentType.LWC_FORM_1010:
                        icon = 'far fa-file-pdf';
                        break;
                    case DocumentType.INBOUND_FAX:
                    case DocumentType.LWC_FORM_1010_RESPONSE:                        
                    case DocumentType.LWC_FORM_1010A:
                    case DocumentType.LWC_FORM_1009_RESPONSE:
                    case DocumentType.REMITTANCE:
                    case DocumentType.CORRESPONDENCE:
                        icon = this.document.read_at ? 'far fa-envelope-open' : 'far fa-envelope';
                        break;
                    case DocumentType.LWC_FORM_1009:
                        icon = 'fas fa-file-contract';
                        break;
                    case DocumentType.LWC_FORM_1010A_RESPONSE:
                        icon = 'fas fa-file-alt';
                        break;
                    case DocumentType.CMS_1500:
                    case DocumentType.CMS_1450:
                        icon = 'fas fa-file-invoice-dollar';
                        break;                                                         
                    default:
                        break;
                }
            }

            return icon + ' fa-lg fa-fw';
        },
        unread: function () {
            return this.document.document_type_id && this.incoming.includes(this.document.document_type_id) && !this.document.read_at;
        },
        showName: function () {
            return this.document.document_type && this.document.document_type.id !== DocumentType.CMS_FORM;
        }          
    },
    methods: {
        getReadContent: function () {
            return 'Read by ' +  this.document.read_by.full_name + ' on ' +  this.$options.filters.localizeTime(this.document.read_at, 'YYYY-MM-DD HH:mm:ss');
        },        
    }
}
</script>

<style scoped>

</style>